import React, { useEffect, useState } from "react";
import Reportselect from "./Reportselect";
import { Link } from "react-router-dom";
import { PiExportBold } from "react-icons/pi";
import { getdriverreport } from "../../services/Reportservice";
import DataTable from "react-data-table-component";
import { Spinner } from "react-bootstrap";
import { IoPrintSharp } from "react-icons/io5";
import { MdFileDownload } from "react-icons/md";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import { driverreportdownloadexcel } from "../../services/Reportservice";
import { FaFilePdf } from "react-icons/fa";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const exportBusPdf = (buses, isSingle = false) => {
  // ✅ Ensure buses is always an array
  const busList = Array.isArray(buses) ? buses : [buses];

  const doc = new jsPDF();
  const currentDate = new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  busList.forEach((bus, index) => {
    const { bus_number, driver, shift_name, route, employees } = bus;

    // === Header ===
    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("Intelishuttle", 14, 12);
    doc.setFont(undefined, "normal");
    doc.setFontSize(10);
    doc.text(`Date: ${currentDate}`, 200, 12, { align: "right" });

    // === Bus Title ===
    doc.setFontSize(16);
    doc.setFont(undefined, "bold");
    doc.text(`Bus No - ${bus_number}`, 14, 24);

    // === Bus Info ===
    doc.setFontSize(12);
    doc.setFont(undefined, "normal");
    doc.text(`Driver Name: ${driver.driver_name}`, 14, 34);
    doc.text(`Driver Phone: ${driver.driver_phone}`, 14, 42);
    doc.text(
      `Route: ${route?.route_name} (No. ${route?.route_number})`,
      14,
      50
    );
    doc.text(`Shift: ${shift_name}`, 14, 58);

    // === Employees Table ===
    const employeeRows = employees.map((emp, i) => [
      i + 1,
      emp.employee_id,
      emp.name,
      emp.email,
      emp.phone,
      emp.stop,
    ]);

    autoTable(doc, {
      startY: 64,
      head: [["#", "Employee ID", "Name", "Email", "Phone", "Stop"]],
      body: employeeRows,
    });

    if (!isSingle && index !== busList.length - 1) {
      doc.addPage();
    }
  });

  const fileName = isSingle
    ? `Bus-${busList[0].bus_number}.pdf`
    : "All-Buses.pdf";
  doc.save(fileName);
};
const EmployeeTable = ({ selectedData = [],checkgender }) => {
   const getRowStyle = (row) => {
    const rule = checkgender?.find((rule) => rule.when(row));
    return rule ? { backgroundColor: rule.style.backgroundColor } : {};
  };
  return (
    <div className="card" style={{ height: "70vh", overflow: "hidden" }}>
      <div className="card-body p-0">
        {selectedData.length === 0 ? (
          <div className="text-center my-2">There are no records found.</div>
        ) : (
          <div
            className="table-responsive"
            style={{ maxHeight: "69vh", overflowY: "auto" }}
          >
            <table className="table fs-6 table-hover align-middle mb-0">
              <thead className="custom-thead table-light sticky-top">
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Stop</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.map((row, index) => (
                  <tr key={index}  style={getRowStyle(row)}>
                    <td>{row?.employee_id || "N/A"}</td>
                    <td>{row?.name || "N/A"}</td>
                    <td>{row?.phone || "N/A"}</td>
                    <td>{row?.stop || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const BusTable = ({
  data = [],
  setSelectedrow,
  handleselect,
  setSelectedbus,
  handleopen,
  conditionalRowStyles = [],
}) => {
  const getRowStyle = (row) => {
  const rule = conditionalRowStyles?.find((rule) => rule.when(row));
  return rule ? rule.style : {};
};
  return (
    <div className="card" style={{ height: "70vh", overflow: "hidden" }}>
      <div className="card-body p-0">
        {data?.length === 0 ? (
          <div className="text-center my-3">There are no records found.</div>
        ) : (
          <div
            className="table-responsive"
            style={{ maxHeight: "69vh", overflowY: "auto" }}
          >
            <table className="table fs-6 align-middle mb-0">
              <thead className="custom-thead table-light sticky-top">
                <tr>
                  <th>Bus Number</th>
                  <th>Route Name</th>
                  <th>Driver Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr
                    key={index}
                   style={{ cursor: "pointer", ...getRowStyle(row) }}
                    onClick={() => {
                      setSelectedrow(row);
                      handleselect(row?.bus_number);
                    }}
                  >
                    <td>
                      <span className="badge bg-primary">
                        {row?.bus_number || "N/A"}
                      </span>
                    </td>
                    <td>
                      <div>
                        <span
                          className="text-primary fw-medium"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {row?.route?.route_name || "N/A"}
                        </span>
                        <br></br>
                        <span
                          className="text-dark fw-medium"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {row?.shift_name || "N/A"}
                        </span>
                      </div>
                    </td>
                    <td>
                      {" "}
                      <div>
                        <span
                          className="text-primary fw-medium"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {row?.driver?.driver_name || "N/A"}
                        </span>
                        <br></br>
                        <span
                          className="text-dark fw-medium"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {row?.driver?.driver_phone || "N/A"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <span
                        // className="badge bg-light"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent parent row click
                          setSelectedbus(row);
                          handleopen();
                        }}
                      >
                        <FaFilePdf
                          className="ms-2"
                          size={18}
                          style={{ color: "rgb(255, 18, 18)" }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const Driverreport = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [selectedData, setSelecteddata] = useState([]);
  const [emploading, setEmploading] = useState(true);
  const [excelloading, setExcelloading] = useState(false);
  const [selectedbus, setSelectedbus] = useState(null);
  const [open, setOpen] = useState(false);
  const [seletedrow, setSelectedrow] = useState(null);
  const handleopen = () => setOpen(true);
  const handleclose = () => setOpen(false);
  const [param, setParam] = useState({
    query: "",
  });
  const getreport = () => {
    setLoading(true);
    setEmploading(true);
    getdriverreport(param)
      .then((res) => {
        setData(res?.data);
        setSelecteddata(res.data[0].employees || []);
        setSelectedrow(res.data[0]);
        setError('')
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "No Data Found"
        );
      })
      .finally(() => {
        setLoading(false);
        setEmploading(false);
      });
  };
  useEffect(() => {
    getreport();
  }, [param]); // re-fetch when the param changes
  const columns = [
    {
      name: "Bus Number",
      selector: (row) => (
        <span className="badge bg-success">{row.bus_number}</span>
      ),
      wrap: true,
    },
    {
      name: "Route Name",
      selector: (row) => row?.route.route_name,
      wrap: true,
    },
    {
      name: "Driver Name",
      selector: (row) => row?.driver.driver_name,
      wrap: true,
    },
    {
      name: "Phone",
      selector: (row) => row?.driver.driver_phone,
      wrap: true,
    },
    {
      name: "Shift",
      selector: (row) => row?.shift_name,
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <span
          className="badge bg-light"
          onClick={() => {
            setSelectedbus(row);
            handleopen();
          }}
        >
          <MdFileDownload size={18} style={{ color: "rgb(55, 108, 241)" }} />
        </span>
      ),
      wrap: true,
      width: "80px",
    },
  ];
  const handleselect = (id) => {
    setEmploading(true);
    setSelecteddata(
      data.find((item) => item.bus_number === id)?.employees || []
    );
    setEmploading(false);
  };
  const employeecolumns = [
    {
      name: "Employee ID",
      selector: (row) => row.employee_id,
      wrap: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      wrap: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      wrap: true,
    },
    {
      name: "Stop",
      selector: (row) => row.stop,
      wrap: true,
    },
  ];
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
    }));
  };
  const handledriverreportexcel = () => {
    setExcelloading(true);
    driverreportdownloadexcel({ ...param, export: "true" })
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "driver-report.xlsx"; // fallback

        if (contentDisposition && contentDisposition.includes("filename=")) {
          filename = contentDisposition
            .split("filename=")[1]
            .split(";")[0]
            .replace(/['"]/g, "");
        }
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error("Error downloading Excel", err);
      })
      .finally(() => {
        setExcelloading(false);
      });
  };
  const handleSingleBusExport = () => {
    exportBusPdf(selectedbus, true);
  };
  const handleAllBusesExport = () => {
    exportBusPdf(data); // Export all
  };
  const conditionalRowStyles = [
    {
      when: (row) => seletedrow && row.bus_id === seletedrow.bus_id,
      style: {
        backgroundColor: "rgba(45, 43, 43, 0.15)", // light blue
        color: "#004085",
        fontWeight: "bold",
      },
    },
  ];
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#482807", // Bootstrap primary blue
        color: "white",
        fontWeight: "bold",
      },
    },
  };
  const checkgender = [
    {
      when: (row) => row.gender?.toLowerCase() === "female", // Adjust based on your key
      style: {
        backgroundColor: "#ffe6f0", // Light pink or any color you like
        color: "#000", // Text color
      },
    },
  ];
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Driver Report
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex flex-wrap gap-2 align-items-center">
            <div style={{ width: "200px" }}>
              <Reportselect />
            </div>
            <div className="flex-fill flex-md-grow-0">
              <DebounceSearchInput handleSearchChange={handleSearchChange} />
            </div>
            <div className="d-flex gap-1">
              <button
                className="btn btn-info d-flex align-items-center gap-1 align-self-center"
                onClick={handledriverreportexcel}
                disabled={excelloading || data.length === 0}
                // style={{ height: "38px" }}
              >
                {" "}
                {excelloading && <Spinner animation="border" size="sm" />}
                <PiExportBold size={18} />
              </button>
              <button
                className="btn btn-success d-flex align-items-center gap-1 align-self-center"
                onClick={handleAllBusesExport}
                // style={{ height: "38px" }}
                disabled={data.length === 0}
              >
                {" "}
                <IoPrintSharp size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-3">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-3">{error}</div>
      ) : (
        <div className="row">
          <div className="col-12 col-md-6">
            <BusTable
              data={data}
              setSelectedrow={setSelectedrow}
              handleselect={handleselect}
              setSelectedbus={setSelectedbus}
              handleopen={handleopen}
              conditionalRowStyles={conditionalRowStyles}
            />
          </div>
          <div className="col-12 col-md-6">
            <EmployeeTable selectedData={selectedData} checkgender={checkgender}/>
          </div>
        </div>
      )}
      <Dialog open={open} onClose={handleclose}>
        <DialogTitle>Download PDF</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to download PDF
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button className="btn btn-outline-danger" onClick={handleclose}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              handleclose();
              handleSingleBusExport();
            }}
          >
            Confirm
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Driverreport;
